import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import type {
  EditAsideDateToSendDatePicker,
  EditAsideExpiryDatePicker,
  EditAsideIssuedDatePicker,
} from '@nodeTypeConfig/configTypes';
import { nlBE } from 'date-fns/locale/nl-BE';
import type React from 'react';
import { datePickerDefaultOptions } from './dateHelper';

const noDisableDate = () => false;

const DatePickerElement: React.FC<{
  config: EditAsideExpiryDatePicker | EditAsideDateToSendDatePicker | EditAsideIssuedDatePicker;
  value: Date | null;
  onChange: (value: Date | null) => void;
  readonly: boolean;
}> = ({ config, value, onChange, readonly }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nlBE}>
      <label className="control-label">{config.label}</label>
      <DatePicker
        format="dd/MM/yyyy"
        value={value}
        onChange={onChange}
        readOnly={readonly}
        openTo={config.options.openTo}
        shouldDisableDate={config.options.shouldDisableDate || noDisableDate}
        slotProps={datePickerDefaultOptions}
      />
    </LocalizationProvider>
  );
};

export default DatePickerElement;
